export const createBlockCanvas = ({
  inputCanvas,
  blockSize,
  blockColour = "#ff0000",
  usePixelColour = false,
  maxSizeMultiplier = 1.2,
  blockShape,
  fadeEdges,
}) => {
  const { width: inputW, height: inputH } = inputCanvas;

  const maxBrightnessBlockSize = blockSize * maxSizeMultiplier;

  const outputCanvas = document.createElement("canvas");
  outputCanvas.width = inputW * blockSize;
  outputCanvas.height = inputH * blockSize;
  const outputCtx = outputCanvas.getContext("2d");

  const inputCtx = inputCanvas.getContext("2d");
  let imgData = inputCtx.getImageData(0, 0, inputW, inputH);
  let pixels = imgData.data;

  let r, g, b, brightness, blockX, blockY;
  // outputCtx.fillStyle = allowGhosting ? "rgba(255,255,255,0.2)" : blockColour;

  const halfBlockSize = blockSize * 0.5;

  outputCtx.fillStyle = blockColour;

  const fadeFraction = 5;
  const amountToFadeX = inputW / fadeFraction;
  const amountToFadeY = inputH / fadeFraction;
  const fadeToX = amountToFadeX;
  const fadeToY = amountToFadeY;
  const fadeFromX = inputW - fadeToX;
  const fadeFromY = inputH - fadeToY;
  const minMultipler = 0.1;

  // const maxOffset = 3;

  for (let y = 0; y < inputH; y++) {
    for (let x = 0; x < inputW; x++) {
      const i = (y * inputW + x) * 4;

      r = pixels[i];
      g = pixels[i + 1];
      b = pixels[i + 2];

      brightness = r * 0.2126 + g * 0.7152 + b * 0.0722;

      let decimalPercentage = brightness / 255;

      if (fadeEdges) {
        if (x < fadeToX) {
          const multiplier = x / fadeToX;
          decimalPercentage *= minMultipler + multiplier;
        }

        if (y < fadeToY) {
          const multiplier = y / fadeToY;
          decimalPercentage *= minMultipler + multiplier;
        }

        if (x > fadeFromX) {
          const multiplier = 1 - (x - fadeFromX) / amountToFadeX;
          decimalPercentage *= minMultipler + multiplier;
        }

        if (y > fadeFromY) {
          const multiplier = 1 - (y - fadeFromY) / amountToFadeY;
          decimalPercentage *= minMultipler + multiplier;
        }
      }

      // block width deterimined by brightness
      const brightnessSize = maxBrightnessBlockSize * decimalPercentage;
      const offset = (maxBrightnessBlockSize - brightnessSize) / 2;

      // const randomOffset = Math.random() * maxOffset;
      // blockX = Math.round(randomOffset + offset + x * blockSize);

      // TODO this Block pos only works for vertical cetner alignment
      blockX = offset + x * blockSize;
      blockY = offset + y * blockSize;

      if (usePixelColour) {
        outputCtx.fillStyle = `rgb(${r * 2.5},${g * 1.5},${b * 1.5})`;
      }
      outputCtx.beginPath();

      if (blockShape === "circle") {
        outputCtx.arc(
          blockX + halfBlockSize,
          blockY + halfBlockSize,
          brightnessSize / 2,
          0,
          Math.PI * 2
        );
        outputCtx.fill();
      } else {
        outputCtx.fillRect(blockX, blockY, brightnessSize, brightnessSize);
      }

      outputCtx.closePath();
    }
  }

  return outputCanvas;
};
